// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ABrbLVQ99t2vRE4sGe8Lm","icons":"_1vR9KOESwhJjGPW-wI-AJ4"};